import { defaultHandleEventClick } from '@sportal365/smp-widget-utils';
import { ConfigContext, Knockout, TextBlock } from '@velinsi/smp-widgets-ui';
import useRootNodeRef from '../../../../../packages/hooks/useRootNodeRef';
import ThemeProvider from '../../../../../packages/theme/ThemeProvider';
import { BaseWidgetProps, IKnockoutConfig, INormalizedKnockout } from '../../../../../packages/types';
import useStage from '../../hooks/useStage';
import { normalizeFootballStageResponseData } from '../../normalizers/normalizeFootballStageResponseData';

export type KnockoutWidgetProps = BaseWidgetProps<IKnockoutConfig>;

export const KnockoutWidget = ({ themes, config, subscribers, shadow, sdkOptions, cuid }: KnockoutWidgetProps) => {
  const { ref } = useRootNodeRef();

  const {
    showWidget,
    handleClick,
    widgetData: { stage, isLoading },
  } = useStage({
    subscribers,
    stageId: config?.dataStage,
    competitionId: config?.dataCompetition,
    seasonId: config?.dataSeason,
    dataWidgetId: config?.dataWidgetId,
    dataWidgetSport: config?.dataWidgetSport,
    dataRefreshTime: config?.dataRefreshTime,
    stageType: 'KNOCK_OUT',
    dataWidgetCuid: cuid,
  });

  if (!showWidget) return null;

  const normalizedKnockoutData = normalizeFootballStageResponseData({
    stage,
    dataEntityLinks: config?.dataEntityLinks,
    dataTeamNameType: config?.dataTeamNameType,
  });

  const normalizedKnockoutDataForPassingProp =
    normalizedKnockoutData?.knockout?.data !== undefined && normalizedKnockoutData?.knockout?.data !== 0
      ? (normalizedKnockoutData?.knockout?.data as INormalizedKnockout[])
      : undefined;

  const handleEventClick = (event: string | number) => defaultHandleEventClick(handleClick, Number(event));

  return (
    <ConfigContext.Provider value={{ ...config, sdkOptions }}>
      <ThemeProvider
        isLoading={isLoading}
        slickStyles={true}
        shadow={shadow}
        themes={themes}
        dataTheme={config?.dataTheme}
        css={{ backgroundColor: '$primaryBackgroundColor' }}
        refForShadow={ref}
      >
        {!normalizedKnockoutDataForPassingProp ? (
          <TextBlock text={config?.dataLabels?.no_matches} />
        ) : (
          <Knockout
            handleEventClick={handleEventClick}
            hasSmallFinal={normalizedKnockoutData?.knockout?.hasSmallFinal}
            smallFinalName={normalizedKnockoutData?.knockout?.smallFinalName}
            normalizedKnockoutData={normalizedKnockoutDataForPassingProp}
          />
        )}
      </ThemeProvider>
    </ConfigContext.Provider>
  );
};
